import { Plugin } from '../../types';
import {loadConfig} from '../../config';
import {isSimilarUrl} from '../../utils/isSimilarUrl'
const config =  loadConfig()
const requestConfig = config.actions && config.actions.request 
const delay = (t = 200) => new Promise((r) => setTimeout(() => r(), t));
const RETRY = 30

export const request: Plugin = {
  name: 'request',
  host: async (page, emit, ) => {
    page.on('response', response => {
      const url = response.request().url()
      if(requestConfig.base){
        if(url.match(requestConfig.base)){
          emit({
            name: 'request',
            type: "response",
            options: {
              status: response.status(),
              url: new URL(response.url()).pathname,
              method: response.request().method()
            },
            time: Date.now()
          });
        }
      }else{
        emit({
          name: 'request',
          type: "response",
          options: {
            status: response.status(),
            url: new URL(response.url()).pathname,
            method: response.request().method()
          },
          time: Date.now()
        });
      }
    });
  },
  generate(event) {
    if (event.type === 'response') {
      return `
      it('receives a \`${event.options.status}\` from ${event.options.method} \`${event.options.url}\`', async ()=>{
        await expect(page).toMatchRequest({
          path: '${event.options.url}',
          status: ${event.options.status},
          method: '${event.options.method}'
        })
      })
      `
    }
    return ''
  },
  test: {
    matchers: {
      toMatchRequest: async function (page, {
        path, method, status
      }) {
        await delay(100)
        
        if(page.openRequests.length){
          while(page.openRequests.length){
            await delay(50)
          }
        }
        let retry = 0;
        while(retry < RETRY){
          const requestIndex = page.requestHistory.findIndex((entry) => {
            if(requestConfig){
              if (isSimilarUrl(entry.path, path, requestConfig as any) && entry.method === method && entry.status === status) {
                return true
              }
            }
            if (isSimilarUrl(entry.path, path.replace(/\/[0-9]*\//g,"/<>/"), {
              patterns: null, base: null
            }) && entry.method === method && entry.status === status) {
              return true
            }
            return false
          })
          if (requestIndex !== -1) {
            page.requestHistory.splice(requestIndex, 1)
            return { pass: true, message: () => "Page made request to " + path };
          }
          await delay(300)
          retry+=1
        }
        console.error(page.requestHistory, path)
    
        return {
          pass: false,
          message: () => "Page did not have request with similar url to " + path +"!=="+ JSON.stringify(page.requestHistory),
        };
      },
    },
    hook: {
      beforeAll: (page) => {
        page.requestHistory = [];
        page.openRequests = [];
        page.on('request', async (request)=>{
          const url = request.url() 
          if(requestConfig && requestConfig.base ){
            if(url.match(requestConfig.base)){
              page.openRequests.push(url)
            }
          }else{
            page.openRequests.push(url)
          }
        })
      
        page.on("response", async (response) => {
          const url = response.request().url()
          if(requestConfig && requestConfig.base){
            if(url.match(requestConfig.base)){
              page.openRequests.splice(page.openRequests.indexOf(response.request().url()), 1)
              page.requestHistory.push({
                path: new URL(response.url()).pathname,
                method: response.request().method(),
                status: response.status(),
              });
            }
          }else{
            page.openRequests.push(url)
            page.requestHistory.push({
              path: new URL(response.url()).pathname,
              method: response.request().method(),
              status: response.status(),
            });
          }
        });
      }
    }
  }
}
export default request